export const ValidateLogoUrl=(str)=> {
    var pattern = new RegExp('^(https?:\/\/.*\.(?:gif|jpeg|jpg|png))');
    return !!pattern.test(str);
}